<script setup lang="ts">
import type { BannersSlider } from './types';
import 'vue3-carousel/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

defineProps<BannersSlider>();

const carouselConfig = {
  itemsToShow: 1,
  wrapAround: true
}
</script>

<template>
  <Carousel v-bind="carouselConfig">
    <Slide v-for="(banner, index) in banners_slider" :key="index">
      <div class="carousel__item">
        <a href="#">
          <img :src="banner.image[0].url"/>
        </a>
      </div>
    </Slide>
    <template #addons>
      <Navigation />
      <Pagination />
    </template>
  </Carousel>
</template>
